import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { routes } from '../../../../constants';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { apiActions as userApiActions } from '../../user/actions';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  EXTERNAL_CPD: {
    ADD: (externalCpd, cpdCategoryPoints, goals, files, nextRoute, testOnly) => ({ externalCpd, cpdCategoryPoints, goals, files, nextRoute, testOnly }),
    API: {
      ADD: apiResourceActionCreator('externalCpd')
    }
  }
})

export const apiAction = (authToken, formData) => commonApiActions.authenticated.postFormData(API_ENDPOINT, authToken, formData, action.externalCpd.api.add)

export function* addExternalCpd({ payload }) {
  const authToken = yield select(authTokenSelector);

  const contentFormData = {
    data: {
      externalCpd: {
        ...payload.externalCpd,
        files: undefined,
        existingFiles: undefined
      },
      goals: payload.goals,
      cpdCategoryPoints: payload.cpdCategoryPoints,
      files: payload.externalCpd.existingFiles ? payload.externalCpd.existingFiles : []
    },
    file: payload.files
  };
  yield put(apiAction(authToken, contentFormData));

  if (!payload.testOnly) {
    const externalCpdResult = yield apiActionResult(action.externalCpd.api.add);

    if (externalCpdResult.success) {
      const {
        nextRoute
      } = payload
      yield put(userApiActions.user.getCpdCategory(authToken));
      yield put(push({ pathname: nextRoute ? nextRoute : routes.app.professionalProfile.root }));
    }
  }

}

const configuration = {
  name: 'add',
  action: action,
  sagas: addExternalCpd,
  reducers: {
    request: (state, action) => fp.flow(
      fp.set('request.add.isFetching')(true),
      fp.set('error')(null)
    )(state),
    success: (state, action) => fp.flow(
      fp.set('request.add.isFetching')(false),
      fp.set('externalCpd')(undefined)
    )(state),
    failed: (state, action) => fp.flow(
      fp.set('request.add.isFetching')(false),
      fp.set('request.add.error')(action.payload.error),
      fp.set('error')(action.payload.error)
    )(state)
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/external-cpd/configurations/add.js